import * as types from '@/store/types'
import * as constants from '@/store/constants'

export default {

    [types.MUTATE_MOFA]: (state, payload) => {            
    	if (payload.request_type_id === constants.FORM_LAND_MOVEMENT) {
        	state.land = payload
        }
    	else if (payload.request_type_id === constants.FORM_AIR) {
    		state.air = payload
        }
    	else if (payload.request_type_id === constants.FORM_SEA) {
    		state.sea = payload
        }
    	else if (payload.request_type_id === constants.FORM_TEMP_VENUE) {            
    		state.temp = payload
        }
    	else if (payload.request_type_id === constants.FORM_NO_STRIKE_LIST) {
    		state.nsl = payload        	
        }
    },
    [types.MUTATE_MOFA_CENTCOM]: (state, payload) => {            
        if (payload.request_type_id === constants.FORM_LAND_MOVEMENT) {
            state.centcom = payload
        }        
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/mofa/mutations.js